import apiEnrollmentInfos from '@/api/enrollment'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  enrollmentInfo: null,
}

export const mutationTypes = {
  getEnrollmentInfoStart: '[enrollmentInfo] Get enrollmentInfo start',
  getEnrollmentInfoSuccess: '[enrollmentInfo] Get enrollmentInfo success',
  getEnrollmentInfoFailure: '[enrollmentInfo] Get enrollmentInfo failure',

  updateEnrollmentInfoStart: '[enrollmentInfo] Update enrollmentInfo start',
  updateEnrollmentInfoSuccess: '[enrollmentInfo] Update enrollmentInfo success',
  updateEnrollmentInfoFailure: '[enrollmentInfo] Update enrollmentInfo failure',

  updateEnrollmentStatusStart:
    '[enrollmentInfo] Update status enrollmentInfo start',
  updateEnrollmentStatusSuccess:
    '[enrollmentInfo] Update status enrollmentInfo success',
  updateEnrollmentStatusFailure:
    '[enrollmentInfo] Update status enrollmentInfo failure',
}

export const actionTypes = {
  getEnrollmentInfo: '[enrollmentInfo] Get enrollmentInfo',
  updateEnrollmentInfo: '[enrollmentInfo] Update enrollmentInfo',
  updateEnrollmentStatus: '[enrollmentInfo] Update status enrollmentInfo',
}

const mutations = {
  [mutationTypes.getEnrollmentInfoStart](state) {
    state.isLoading = true
    state.enrollmentInfo = null
  },

  [mutationTypes.getEnrollmentInfoSuccess](state, payload) {
    state.enrollmentInfo = payload
    state.isLoading = false
  },

  [mutationTypes.getEnrollmentInfoFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.updateEnrollmentInfoStart](state) {
    state.isLoading = true
    state.enrollmentInfo = null
  },

  [mutationTypes.updateEnrollmentInfoSuccess](state, payload) {
    state.enrollmentInfo = payload
    state.isLoading = false
  },

  [mutationTypes.updateEnrollmentInfoFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.updateEnrollmentStatusStart](state) {
    state.isLoading = true
  },

  [mutationTypes.updateEnrollmentStatusSuccess](state) {
    state.isLoading = false
  },

  [mutationTypes.updateEnrollmentStatusFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getEnrollmentInfo](context, {id}) {
    context.commit(mutationTypes.getEnrollmentInfoStart)
    return new Promise((resolve) => {
      apiEnrollmentInfos
        .getEnrollmentInfo(id)
        .then((response) => {
          context.commit(mutationTypes.getEnrollmentInfoSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getEnrollmentInfoFailure)
        })
    })
  },

  [actionTypes.updateEnrollmentInfo](context, enrollmentInfo) {
    context.commit(mutationTypes.updateEnrollmentInfoStart)
    return new Promise((resolve) => {
      apiEnrollmentInfos
        .changeEnrollment(enrollmentInfo)
        .then((response) => {
          context.commit(
            mutationTypes.updateEnrollmentInfoSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.updateEnrollmentInfoFailure)
        })
    })
  },

  [actionTypes.updateEnrollmentStatus](context, {feedbackId, data}) {
    context.commit(mutationTypes.updateEnrollmentStatusStart)
    return new Promise((resolve) => {
      apiEnrollmentInfos
        .changeEnrollmentStatus(feedbackId, data)
        .then((response) => {
          context.commit(
            mutationTypes.updateEnrollmentStatusSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.updateEnrollmentStatusFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
